'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _reactTransitionGroup = require('react-transition-group');

var _entry = require('./entry');

var _entry2 = _interopRequireDefault(_entry);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_style2.default);

var Popover = function (_PureComponent) {
  _inherits(Popover, _PureComponent);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: false
    }, _this.toggleVisible = function () {
      return _this.setState({ visible: !_this.state.visible });
    }, _this.handleClickOutside = function () {
      return _this.setState({ visible: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          entry = _props.entry,
          _props$trigger = _props.trigger,
          trigger = _props$trigger === undefined ? 'click' : _props$trigger,
          position = _props.position;


      var popoverProps = trigger === 'click' ? {
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.toggleVisible();
        }
      } : {
        onMouseEnter: function onMouseEnter(e) {
          e.preventDefault();
          _this2.setState({ visible: true });
        }
      };

      return _react2.default.createElement(
        'div',
        { className: cx('xsui-popover') },
        _react2.default.cloneElement(children, popoverProps),
        _react2.default.createElement(
          _reactTransitionGroup.TransitionGroup,
          null,
          this.state.visible && _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            { classNames: 'fade', timeout: 100 },
            _react2.default.createElement(
              _entry2.default,
              {
                onMouseLeave: trigger === 'hover' ? this.handleClickOutside : void 0,
                position: position },
              entry
            )
          )
        )
      );
    }
  }]);

  return Popover;
}(_react.PureComponent);

Popover.propTypes = {
  children: function children() {
    return (typeof React$Element === 'function' ? _propTypes2.default.instanceOf(React$Element).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
  },
  entry: function entry() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
  },
  trigger: _propTypes2.default.oneOf(['click', 'hover']),
  position: _propTypes2.default.oneOf(['top', 'bottom', 'below'])
};
exports.default = (0, _reactOnclickoutside2.default)(Popover);